import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bool } from 'prop-types'
import Hammer from 'react-hammerjs'
import { toggleSidebar } from '../../../../store/Actions/UiActions'
import SidebarHeader from '../SidebarHeader'
import Categories from '../Categories'
import Settings from '../Settings'
import Links from '../Links'
import Version from '../Version'
import '../styles/SidebarContainer.css'

class SidebarContainer extends PureComponent {
  render() {
    return (
      <Hammer
        onSwipe={() => this.props.toggleSidebar(!this.props.sidebarOpen)}
        direction="DIRECTION_LEFT"
      >
        <div className="sidebar-container animated slideInLeft">
          <SidebarHeader />
          <Categories />
          <Settings />
          <Links />
          <Version />
        </div>
      </Hammer>
    )
  }
}

SidebarContainer.propTypes = {
  sidebarOpen: bool.isRequired,
}

const mapStateToProps = ({ ui }) => ({
  sidebarOpen: ui.sidebarOpen,
})

const mapDispatchToProps = dispatch => ({
  toggleSidebar: value => dispatch(toggleSidebar(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SidebarContainer)



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/SidebarContainer/index.jsx